import { getCsrfToken } from '@/api/getCsrfTokenRequest.util.ts';
import { HTTP_HEADER } from '@/api/util/httpHeaders.model.ts';
import CONFIG from '@/config/config.ts';
import { RoutesEnum } from '@/routes/Routes.enum.ts';
import { useMutation } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';

type Response = void;

type Return = {
  isLoggingOut: boolean;
  logout: () => Promise<Response>;
};

export const useLogout = (): Return => {
  const { isPending, mutateAsync } = useMutation<Response, AxiosError>({
    mutationFn: async () => {
      const csrfToken = await getCsrfToken();
      const headers: Record<string, string> = {
        [HTTP_HEADER['X-CSRF-TOKEN']]: csrfToken,
      };
      if (CONFIG.ENVIRONMENT === 'local') {
        headers['x-auth-token'] = `${CONFIG.JSESSION}`;
      }

      await axios.post(
        CONFIG.HOST + '/api/logout',
        {},
        {
          headers,
        },
      );
      window.location.href = CONFIG.HOST + RoutesEnum.ROOT;
    },
  });

  return {
    isLoggingOut: isPending,
    logout: mutateAsync,
  };
};
